// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Gameover_wrapper__fCY_t","menu":"Gameover_menu__1YV26"};